export const UPDATE_ACCOUNT_INFO = "UPDATE_ACCOUNT_INFO";
export const UPDATE_INVESTMENT_INFO = "UPDATE_INVESTMENT_INFO";
export const UPDATE_SIGNUP_OPTION = "UPDATE_SIGNUP_OPTION";
export const SHOW_OTP_FORM = "SHOW_OTP_FORM";
export const SHOW_NIN_FULL_FORM = "SHOW_NIN_FULL_FORM";
export const NEXT_STEP = "NEXT_STEP";
export const PREVIOUS_STEP = "PREVOUS_STEP";
export const CLEAR_ONBOARDING = "CLEAR_ONBOARDING";
